export default [
    {
        step: 1,
        name: 'StafetDeltagPaaHoldStepSelectTeam',
        completed: false,
        label: 'formStepLabelSelectTeam',
        hidden: false
    },
    {
        step: 2,
        name: 'StafetDeltagPaaHoldStepYourInformation',
        completed: false,
        label: 'formStepLabelYourInformation',
        hidden: false
    },
    {
        step: 3,
        name: 'FormStepSubmitting',
        completed: false,
        skipped: true,
        label: 'formStepSubmission',
        hidden: false
    }
]
